var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import React from 'react'
import { ODSearchBox } from '../../form/ODSearchBox'
export function ODListableSearchBox(props) {
  var placeholder = props.placeholder,
    _a = props.style,
    style = _a === void 0 ? {} : _a,
    listableContext = props.listableContext,
    _b = props.filterKey,
    filterKey = _b === void 0 ? 'filter' : _b
  var _c = React.useContext(listableContext),
    updateLoadOption = _c.updateLoadOption,
    loadOption = _c.state.loadOption
  var runSearch = React.useCallback(
    function (value) {
      var _a
      updateLoadOption(__assign(__assign({}, loadOption), ((_a = {}), (_a[filterKey] = value), _a)))
    },
    [updateLoadOption, loadOption, filterKey]
  )
  return React.createElement(ODSearchBox, {
    placeholder: placeholder,
    style: style,
    value: loadOption[filterKey],
    onChange: runSearch,
  })
}
//# sourceMappingURL=ODListableSearchBox.js.map
